import { render, staticRenderFns } from "./JobAssignmentOrderFloatBtns.vue?vue&type=template&id=473bf40f&"
import script from "./JobAssignmentOrderFloatBtns.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentOrderFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports